import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";

export default function ProfilePage() {
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const { logindata, setlogindata, userData, setuserData } = context;

  const [isEditing, setIsEditing] = useState(false);
  const [profile, setProfile] = useState({
    name: "Rahul Sharma",
    email: "rahul.sharma@email.com",
    phone: "+91 98765 43210",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20indian%20man%20portrait%20photo%20headshot%20with%20neutral%20background%2C%20clean%20modern%20style%2C%20friendly%20smile%2C%20business%20casual%20attire&width=200&height=200&seq=avatar1&orientation=squarish",
  });

  const [editedProfile, setEditedProfile] = useState(profile);

  const [LedgerName, setLedgerName] = useState(userData?.LedgerName ?? "");
  const [LedgerEmail, setLedgerEmail] = useState(userData?.SignInEmail ?? "");

  useEffect(() => {
    window.scrollTo(0, 0);
  },[])

  const handleSave = () => {
    setProfile(editedProfile);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditedProfile(profile);
    setIsEditing(false);
  };

  const updateProfile = () => {
    let Body = [
      {
        LedgerID: userData?.LedgerID,
        LedgerName: LedgerName,
        SignInEmail: LedgerEmail,
      },
    ];

    PostRecords(526, 1, Body, (response: any) => {
      if (!response?.hasErrors) {
        const updatedUser = {
          ...userData,
          LedgerName : LedgerName,
          SignInEmail: LedgerEmail,
        };

        setuserData(updatedUser);
        localStorage.setItem(
          "UserData-UniversalDairy",
          JSON.stringify(updatedUser),
        );
        setIsEditing(false);
      }
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <main className="pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm mb-8">
            <Link to="/" className="text-gray-500 hover:text-amber-600">
              Home
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900 font-medium">My Profile</span>
          </nav>

          <div className="bg-white rounded-xl shadow-sm overflow-hidden">
            {/* Profile Header */}
            <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-8 py-12">
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="relative">
                  <img
                    src={
                      userData?.LogoPic ||
                      "https://dialerpstorageac.blob.core.windows.net/10417/36/2596/2.png"
                    }
                    alt={userData?.LedgerName || ""}
                    className="w-28 h-28 rounded-full border-4 border-white shadow-lg object-cover"
                  />
                  <button className="absolute bottom-0 right-0 w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center text-gray-600 hover:text-amber-600 cursor-pointer">
                    <i className="ri-camera-line text-lg"></i>
                  </button>
                </div>
                <div className="text-center md:text-left">
                  <h1 className="text-2xl font-bold text-white">
                    {userData?.LedgerName || ""}
                  </h1>
                  <p className="text-amber-100 mt-1">
                    {userData?.SignInEmail || ""}
                  </p>
                  <p className="text-amber-100 text-sm mt-1">
                    Member since  {new Date(userData?.cDt).toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}{" "}
                  </p>
                </div>
              </div>
            </div>

            {/* Profile Content */}
            <div className="p-8">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-semibold text-gray-900">
                  Personal Information
                </h2>
                {!isEditing ? (
                  <button
                    onClick={() => setIsEditing(true)}
                    className="flex items-center gap-2 px-4 py-2 text-amber-600 hover:bg-amber-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-edit-line"></i>
                    Edit Profile
                  </button>
                ) : (
                  <div className="flex gap-3">
                    <button
                      onClick={handleCancel}
                      className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => updateProfile()}
                      className="px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Save Changes
                    </button>
                  </div>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-500 mb-2">
                    Full Name
                  </label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={LedgerName}
                      onChange={(e) => setLedgerName(e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                    />
                  ) : (
                    <p className="text-gray-900 font-medium">
                      {userData?.LedgerName || ""}
                    </p>
                  )}
                </div>

                  <div>
                  <label className="block text-sm font-medium text-gray-500 mb-2">
                    Mobile Number
                  </label>
                 
                    <p className="text-gray-900 font-medium">
                      {userData?.SignInMobile || ""}
                    </p>
                  
                </div>



                <div>
                  <label className="block text-sm font-medium text-gray-500 mb-2">
                    Email Address
                  </label>
                  {isEditing ? (
                    <input
                      type="email"
                      value={LedgerEmail}
                      onChange={(e) => setLedgerEmail(e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                    />
                  ) : (
                    <p className="text-gray-900 font-medium">
                      {userData?.SignInEmail || ""}
                    </p>
                  )}
                </div>

                {/* <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-500 mb-2">Phone Number</label>
                  {isEditing ? (
                    <input
                      type="tel"
                      value={editedProfile.phone}
                      onChange={(e) => setEditedProfile({ ...editedProfile, phone: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                    />
                  ) : (
                    <p className="text-gray-900 font-medium">{userData?.SignInMobile || profile.phone}</p>
                  )}
                </div> */}
              </div>

              {/* Quick Links */}
              <div className="mt-10 pt-8 border-t border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Quick Links
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  <Link
                    to="/orders"
                    className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-amber-50 transition-colors cursor-pointer"
                  >
                    <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                      <i className="ri-shopping-bag-line text-amber-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">My Orders</p>
                      <p className="text-sm text-gray-500">Track orders</p>
                    </div>
                  </Link>
                  
                  <Link
                    to="/address"
                    className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-amber-50 transition-colors cursor-pointer"
                  >
                    <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                      <i className="ri-map-pin-line text-amber-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">My Addresses</p>
                      <p className="text-sm text-gray-500">Manage addresses</p>
                    </div>
                  </Link>

                  <Link
                    to="/cart"
                    className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-amber-50 transition-colors cursor-pointer"
                  >
                    <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                      <i className="ri-shopping-cart-line text-amber-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">Shopping Cart</p>
                      <p className="text-sm text-gray-500">View cart</p>
                    </div>
                  </Link>

                  <Link
                    to="/help"
                    className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-amber-50 transition-colors cursor-pointer"
                  >
                    <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                      <i className="ri-question-line text-amber-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">Help Center</p>
                      <p className="text-sm text-gray-500">Get support</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
